import RequestDeputy from "./RequestDeputyContainer";

export default RequestDeputy;
